module.exports = __webpack_public_path__ + "img/offline-big.afa6698d.svg";